const IST = "Asia/Kolkata";

export const formatDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric", timeZone: IST }) : "-";

export const formatDateTime = (d) =>
  d
    ? new Date(d).toLocaleString("en-IN", {
        day: "2-digit", month: "short", year: "numeric",
        hour: "2-digit", minute: "2-digit", hour12: true, timeZone: IST,
      })
    : "-";

// "18:30" -> "06:30 PM"
export const formatSlot = (slot) => {
  if (!slot) return "-";
  const [h, m] = slot.split(":").map(Number);
  return new Date(1970, 0, 1, h, m).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });
};

// 643 -> "10m 43s"
export const formatDuration = (sec) => {
  if (sec === null || sec === undefined) return "-";
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return m ? `${m}m ${s}s` : `${s}s`;
};

export const formatDistance = (m) => {
  if (!m) return "-";
  const n = Math.round(m);
  return n < 1000 ? `${n} m` : `${(n / 1000).toFixed(1)} km`;
};

// TOMTOM_INC|<id> = jam reported by TomTom, TOMTOM|<road id> = travel time of a stored road
export const kindOf = (row) => (row?.road_key && row.road_key.startsWith("TOMTOM_INC|") ? "INCIDENT" : "ROAD");
export const KIND_LABEL = { INCIDENT: "Incident", ROAD: "Road" };

export const LEVELS = ["LOW", "MODERATE", "HEAVY", "SEVERE"];

// 00:00, 00:30 ... 23:30
export const SLOTS = Array.from({ length: 48 }, (_, i) => {
  const m = i * 30;
  return `${String(Math.floor(m / 60)).padStart(2, "0")}:${m % 60 ? "30" : "00"}`;
});

export const speedText = (s) => (s === "TRAFFIC_JAM" ? "Jam" : s === "SLOW" ? "Slow" : "-");
export const speedLevel = (s) => (s === "TRAFFIC_JAM" ? "SEVERE" : "HEAVY");

export const routeText = (row) => {
  const a = row?.from?.name;
  const b = row?.to?.name;
  if (a && b && a !== b) return `${a} → ${b}`;
  return row?.route_via || a || b || "-";
};